<template>
  <div>
    <div
      v-if="isLoadingAll"
      style="text-align: center;
        overflow: hidden;
        height: 100%;
        position: inherit;
        width: 100%;"
    >
      <img
        src="@/assets/images/giphy2.gif"
        style="position: absolute;
        right: 216px;"
      >
      <div
        style="width: 100%;
        height: 100%;
        background-color: #656565;
        opacity: 0.5;
        position: absolute;
        z-index: 10;"
      />
    </div>
    <div>
      <span v-if="!fieldObject">Wählen Sie zuerst eine Branche aus</span>

      <div v-else>
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <div class="advancedSearchButtonsWrapper">
          <button
            v-if="!editMode"
            v-b-tooltip.hover
            class="btn btn-primary"
            placement="bottom"
            title="Branche bearbeiten"
            type="button"
            @click="editMode = !editMode"
          >
            <i class="fas fa-edit" />
          </button>
          <button
            v-if="!editMode"
            v-b-modal="'confirmDeleteBranch' + customBranchTypeId"
            v-b-tooltip.hover
            class="btn btn-danger ml-1"
            placement="bottom"
            title="Branche löschen"
            type="button"
          >
            <i class="fas fa-trash-alt" />
          </button>
        </div>
        <b-modal
          :id="'confirmDeleteBranch' + customBranchTypeId"
          :ref="'confirmDeleteBranch' + customBranchTypeId"
          hide-footer
          no-fade
          title="Branche löschen"
        >
          <div class="d-block mb-4">
            Sind Sie sicher, dass Sie diese Branche löschen möchten?
          </div>
          <b-button
            variant="success"
            @click="deleteBranch()"
          >
            Ok
          </b-button>
          <b-button
            class="ml-2"
            variant
            @click="hideModal"
          >
            Abbrechen
          </b-button>
        </b-modal>

        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label
                :for="fieldObject.code"
                class="pl-0 col-3 defaultLabel"
              >Titel</label>
              <div
                v-if="!editMode"
                class="col-9 pl-0"
              >
                {{ fieldObject.code }}
              </div>
              <div
                v-else
                class="col-9 pl-0"
              >
                <v-text-field
                  v-model="fieldObject.code"
                  label="Titel"
                />
              </div>
            </b-row>
          </b-container>
        </div>
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label class="pl-0 col-3 defaultLabel">Name</label>
              <div
                v-if="!editMode"
                class="col-9 pl-0"
              >
                {{
                  fieldObject.customBranchContents[fieldContentIds[0].value]
                    .value
                }}
              </div>
              <div
                v-else
                class="col-9 pl-0"
              >
                <v-flex sm12>
                  <u-multiline-multilanguage-text-input
                    :id="'fieldName' + index"
                    v-model="fieldObject.customBranchContents"
                    content-property-name="value"
                  />
                </v-flex>
              </div>
            </b-row>
          </b-container>
        </div>
        <!-- For now, there is no description on branches
      <div class="form-group">
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              class="pl-0 col-3 defaultLabel"
            >Beschreibung</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              {{ fieldObject.customBranchContents[fieldContentIds[0].value].Description }} 
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <u-multiline-multilanguage-text-input
                  :id="'fieldDescription' + index"
                  v-model="fieldObject.customBranchContents"
                  :is-multiline="true"
                  content-property-name="Description"
                />
              </v-flex>
            </div>
          </b-row>
        </b-container>
      </div> -->
        <div class="form-group">
          <b-container class="pb-0 pt-0">
            <b-row>
              <label class="pl-0 col-3 defaultLabel">Noga-Branchen</label>
            </b-row>
            <b-row>
              <div
                v-if="!editMode"
                class="col-12 pl-0"
              >
                <ul>
                  <li
                    v-for="(topLevelBranche, index) in allTopLevelBranchen"
                    :key="index"
                  >
                    {{ topLevelBranche.nogaCode + " " + topLevelBranche.value }}
                  </li>
                </ul>
              </div>
              <div
                v-else
                class="pl-0 containerNogaBranches"
              >
                <div style="width: 250%;">
                  <u-tree-view
                    v-if="!isLoading"
                    v-model="fieldObject.nogaPaths"
                    :tree-view-items="treeViewData"
                  />
                </div>
              </div>
            </b-row>
          </b-container>
        </div>
        <div
          v-if="editMode"
          class="mt-4"
        >
          <button
            v-if="fieldObject.id != 0"
            v-b-tooltip.hover
            class="btn btn-success ml-2"
            placement="bottom"
            title="Speichern"
            type="button"
            @click="saveNogaBranches"
          >
            Speichern
          </button>

          <button
            v-else
            v-b-tooltip.hover
            class="btn btn-success ml-2"
            placement="bottom"
            title="Hinzufügen"
            type="button"
            @click="createNewBranch"
          >
            Hinzufügen
          </button>

          <button
            v-b-tooltip.hover
            class="btn btn-danger ml-2"
            placement="bottom"
            title="Abbrechen"
            type="button"
            @click="cancelEdit()"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
    <div
      class="w-100"
      style="text-align: right;"
    >
      <span>
        <button
          v-if="!editMode && $IsUserInRole('VertragsmanagementVerwaltung')"
          v-b-tooltip.hover
          class="btn btn-success"
          placement="bottom"
          title="Branche hinzufügen"
          type="button"
          @click="addNewBranche"
        >
          <i class="fas fa-plus" />
        </button>
      </span>
    </div>
  </div>
</template>

<script>
    import {
        GetSingleField,
        UpdateBranch,
        CreateNewBranch,
        DeleteBranch
    } from "@/services/Branches.service.js";

    import UTreeView from "@/components/common/UTreeView.vue";
    import {
        CreateTreeView,
        CreateTopLevelBranchenList
    } from "@/helpers/TreeViewHelper.js";

    export default {
        components: {
            UTreeView
        },
        props: {
            field: {
                type: Object,
                default: null
            },
            anchorId: {
                type: String,
                default: ""
            },
            customBranchTypeId: {
                type: Number,
                default: 1
            },
            allNogaBranches: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                fieldObject: null,
                originalFieldObject: null,
                errorObject: null,
                editMode: false,
                isLoading: false,
                isLoadingAll: false,
                allTopLevelBranchen: [],
                treeViewData: [],
                fieldContentIds: [
                    { language: "de-CH", value: -1 },
                    { language: "fr-CH", value: -1 },
                    { language: "it-CH", value: -1 }
                ]
            };
        },
        watch: {
            field() {
                this.errorObject = null;
                this.editMode = false;
                this.loadCurrentField();
            }
        },
        created() {
        },
        methods: {
            hideModal() {
                this.$refs["confirmDeleteBranch" + this.customBranchTypeId].hide();
            },
            deleteBranch() {
                this.hideModal();
                this.isLoadingAll = true;

                DeleteBranch(
                    this.fieldObject.id,
                    () => {
                        this.isLoadingAll = false;
                        this.$emit("itemsChanged", this.customBranchTypeId);
                        window.location = "#" + this.anchorId;
                    },
                    error => {
                        this.isLoadingAll = false;
                        this.errorObject = error;
                    }
                );
            },
            saveNogaBranches() {
                this.errorObject = null;
                this.isLoadingAll = true;

                UpdateBranch(
                    this.fieldObject,
                    () => {
                        this.editMode = false;

                        this.isLoadingAll = false;
                        this.$emit(
                            "itemsChanged",
                            this.customBranchTypeId,
                            this.fieldObject.id
                        );
                        window.location = "#" + this.anchorId;
                    },
                    error => {
                        this.errorObject = error;
                        this.isLoadingAll = false;
                        window.location = "#" + this.anchorId;
                    }
                );
            },
            createNewBranch() {
                CreateNewBranch(
                    this.fieldObject,
                    createdBranch => {
                        this.editMode = false;
                        this.$emit("itemsChanged", this.customBranchTypeId, createdBranch.id);
                        window.location = "#" + this.anchorId;
                    },
                    error => {
                        this.errorObject = error;
                        window.location = "#" + this.anchorId;
                    }
                );
            },
            addNewBranche() {
                this.fieldObject = JSON.parse(
                    JSON.stringify({
                        id: 0,
                        code: "",
                        customBranchTypeId: this.customBranchTypeId,
                        nogaPaths: [],
                        contentSortingOrder: 0,
                        order: 0,
                        customBranchContents: [
                            {
                                id: 0,
                                customBranchId: 0,
                                value: "",
                                language: "de-CH"
                            },
                            {
                                id: 0,
                                customBranchId: 0,
                                value: "",
                                language: "fr-CH"
                            },
                            {
                                id: 0,
                                customBranchId: 0,
                                value: "",
                                language: "it-CH"
                            }
                        ]
                    })
                );

                this.createTreeViewJson();
                this.editMode = true;
            },
            loadCurrentField() {
                GetSingleField(
                    this.field.customBranchId,
                    response => {
                        this.fieldObject = response;
                        this.originalFieldObject = JSON.parse(JSON.stringify(response));
                        this.fieldContentIds.map(contractContentLangaugeSetting => {
                            var languageSetting = this.fieldObject.customBranchContents.filter(
                                contractContent => {
                                    return (
                                        contractContent.language ==
                                        contractContentLangaugeSetting.language
                                    );
                                }
                            );

                            if (languageSetting.length == 1) {
                                contractContentLangaugeSetting.value = this.fieldObject.customBranchContents.indexOf(
                                    languageSetting[0]
                                );
                            }
                        });

                        this.createTreeViewJson();
                        this.loadTopLevelBranches();
                    },
                    error => {
                        this.errorObject = error;
                    }
                );
            },
            cancelEdit() {
                this.errorObject = null;
                this.fieldObject = JSON.parse(JSON.stringify(this.originalFieldObject));
                this.editMode = false;
                window.location = "#" + this.anchorId;
            },
            loadTopLevelBranches() {
                this.allTopLevelBranchen = CreateTopLevelBranchenList(
                    this.allNogaBranches,
                    this.fieldObject.nogaPaths
                );
            },
            createTreeViewJson() {
                this.treeViewData = CreateTreeView(this.allNogaBranches);
            }
        }
    };
</script>

<style scoped>
.advancedSearchButtonsWrapper {
  width: 100%;
  display: inline-block;
  text-align: right;
}

.containerNogaBranches {
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
</style>
